var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"innerPage"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"table",staticStyle:{"height":"100%"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.info.leave_url,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }